import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel, IconButton,
    Input,
    InputGroup,
    InputRightElement,
    Modal, ModalContent, ModalOverlay,
    Select,
    Text, useDisclosure, useToast,
    Container,
    Card,
    CardHeader,
    CardBody,
    SimpleGrid,
    Icon,
    VStack,
    HStack,
    Stack,
    ModalCloseButton
} from "@chakra-ui/react";
import { BrandButton, GhostButton } from "../../components/TablePageShell";
import { useTranslation } from "react-i18next";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import React, { useEffect, useState, useCallback } from "react";
import "nepali-datepicker-reactjs/dist/index.css"
import { DisabilityType, Student } from "../../interfaes/student";
import addressData from '../../data/address.json';
import DistictData from '../../data/District.json';
import LocalLevelData from '../../data/localLevelData.json';
import LocalLevelDataNepali from '../../data/localLevelDataNe.json';
import { Address, District, Municipality } from "../../interfaes/address";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DEFAULTSTUDENT } from "../../interfaes/fixture";
import _find from "lodash/find";
import _filter from "lodash/filter";
import { onGetSchools } from "../../http/school";
import { School } from "../../interfaes/school";
import { onGetTherapist, onGetUsers } from "../../http/users";
import { Roles, User } from "../../interfaes/user";
import Joi from "joi";
import { errorFormat, FormattedError, getErrorMessage, hasErrorMessage } from "../../utils/formUtils";
import { onAddNewStudent, onUpdateStudent } from "../../http/student";
import ImageUpload from "../../components/ImageUpload";
import NepaliDateConverter from "nepali-date-converter";
import { MdAdd } from "react-icons/md";
import { FiUser, FiInfo, FiBriefcase, FiMapPin } from "react-icons/fi";
import ManageUsers from "../users/ManageUsers";
import ManageSchool from "../school/ManageSchool";
import { FaArrowLeft } from "react-icons/fa";

// @ts-ignore
const address: Address[] = addressData;
const districts: District[] = DistictData;




export default function ManageStudent() {
    const [disability, setDisability] = useState('false');

    const schema = Joi.object({
        fullName: Joi.string()
            .required(),

        dob: Joi.date().required(),
        gender: Joi.string().optional(),
        language: Joi.string().required(),
        disabilityType: disability === 'true' ? Joi.string().required() : Joi.string().allow('').optional(),
        disabilityId: disability === 'true' ? Joi.string().required() : Joi.string().allow('').optional(),
        serviceArea: Joi.string().required(),
        parentId: Joi.string().required(),
        schoolId: Joi.string().optional().allow('').allow(null),
        therapistId: Joi.string().optional().allow('').allow(null),
        province: Joi.string().required(),
        district: Joi.string().required(),
        localLevel: Joi.string().required(),
        localAddress: Joi.string().required(),
        tempProvince: Joi.string().required(),
        tempDistrict: Joi.string().required(),
        tempLocalLevel: Joi.string().required(),
        tempLocalAddress: Joi.string().required(),
        category: Joi.string().optional().allow('').allow(null),
        specialDisability: Joi.required(),
        IEMISNumber: Joi.string().optional().allow('').allow(null),
        contact: Joi.required(),
        studentImage: Joi.optional(),
        disabilityDetail: Joi.optional(),
        nationalId: Joi.string().optional().allow('').allow(null),
    });
    const [showLanguageOthers, setShowLanguageOthers] = useState<boolean>(false);
    const [showServiceAreaOthers, setShowServiceAreaOthers] = useState<boolean>(false);

    const { state } = useLocation();

    const [loading, setLoading] = useState<boolean>(false);
    const [copyAddress, setCopyAddress] = useState<boolean>(false);

    const { id } = useParams();
    const navigate = useNavigate();
    const [date, setDate] = useState<string>("2049-02-28");
    const [district, setDistrict] = useState<number>(0);
    const [districtTemp, setDistrictTemp] = useState<number>(0);
    const { t, i18n } = useTranslation('studentLocal');
    const toast = useToast();

    const [localLevel, setLocalLevel] = useState<number>(0);
    const [localLevelTemp, setLocalLevelTemp] = useState<number>(0);

    const [addInModal, setAddInModal] = useState<string>('');


    const [student, setStudent] = useState<Student>(
        state ? {
            "fullName": state.fullName,
            "dob": state.dob,
            "gender": state.gender,
            "language": state.language,
            "disabilityType": state.disabilityType,
            "category": state.category,
            "specialDisability": state.specialDisability,
            "contact": state.contact,
            "schoolId": state.schoolId,
            "province": state.province,
            "district": state.district,
            "localLevel": state.localLevel,
            "localAddress": state.localAddress,
            "serviceArea": state.serviceArea,
            "parentId": state.parentId,
            "therapistId": state.therapistId,
            "IEMISNumber": state.IEMISNumber,
            "nationalId": state.nationalId,
            "disabilityId": state.disabilityId,
            studentImage: state.studentImage,
            disabilityDetail: state.disabilityDetail,
            tempProvince: state.tempProvince,
            tempDistrict: state.tempDistrict,
            tempLocalLevel: state.tempLocalLevel,
            tempLocalAddress: state.tempLocalAddress



        } :
            DEFAULTSTUDENT);


    const [school, setSchool] = useState<School[]>([]);
    const [parents, setParents] = useState<User[]>([]);
    const [therapist, setTherapist] = useState<User[]>([]);
    const localLevelData: Municipality[] = i18n.language === 'en' ? LocalLevelData : LocalLevelDataNepali;
    const [formErrors, setFormErrors] = useState<FormattedError[]>([]);

    const onGetDOB = useCallback((timeStamp: number) => {
        const date = new Date(timeStamp);
        const convertedDate = NepaliDateConverter.fromAD(date);
        setDate(convertedDate.format("YYYY-MM-DD"));
    }, []);

    const getSchools = useCallback(async () => {
        try {
            const response = await onGetSchools();
            setSchool(response.data.items);
        } catch (e) {
            console.log(e)
        }
    }, []);

    const getTherapist = useCallback(async () => {
        try {
            const response = await onGetTherapist();
            const t = response.data.userResponseList.filter((e: User) => {
                return e?.roles?.includes(Roles.THERAPIST)
            })
            setTherapist(t);
        } catch (e) {
            console.log(e);
        }
    }, []);

    const getUsers = useCallback(async () => {
        try {
            const response = await onGetUsers();
            const p = response.data.userResponseList.filter((e: User) => {
                return e?.roles?.includes(Roles.PARENT)
            });
            setParents(p);
        } catch (e) {
            console.log(e);
        }
    }, []);

    useEffect(() => {
        getSchools();
        getTherapist();
        getUsers();
    }, [getSchools, getTherapist, getUsers]);

    useEffect(() => {
        if (state) {
            onGetDOB(state.dob);
            const provId = _find(address, ['name', state.province]);
            setDistrict(provId ? provId.id : 0);
            const tempProvId = _find(address, ['name', state.tempProvince]);
            setDistrictTemp(tempProvId ? tempProvId.id : 0);
            const dis = _find(districts, ['name', state.district]);
            setLocalLevel(dis ? dis.id : 0);
            const dis1 = _find(districts, ['name', state.tempDistrict]);
            setLocalLevelTemp(dis1 ? dis1.id : 0);
            setDisability(state.disabilityType !== '' ? 'true' : 'false')
            if (!['NEPALI', 'RAUTE', 'MAITHALI', 'TAMANG', 'NEWARI', 'KIRAT', 'OTHERS'].includes(state.language)) {
                setShowLanguageOthers(true);
            }
            if (!['COMMUNITY', 'HOME', 'SCHOOL'].includes(state.serviceArea)) {
                setShowServiceAreaOthers(true);
            }
        }
    }, [state, onGetDOB]);
    const validateObj = () => {
        const { error } = schema.validate(student);
        console.log(error, student);
        if (error) {
            setFormErrors(errorFormat(error.details));
            return false;
        }

        setFormErrors([]);
        return true;
    }

    const handleUpdateStudent = async () => {
        if (validateObj()) {
            try {
                if (id) {
                    setLoading(true);

                    if (id === 'add') {
                        await onAddNewStudent(student);
                        toast({
                            title: 'Success',
                            description: 'Student added successfully!',
                            status: 'success',
                            duration: 3000,
                            isClosable: true,
                        });
                        navigate(-1);
                    } else {
                        await onUpdateStudent(student, id);
                        toast({
                            title: 'Success',
                            description: 'Student updated successfully!',
                            status: 'success',
                            duration: 3000,
                            isClosable: true,
                        });
                        navigate(-1);
                    }
                }

            } catch (e: any) {
                console.log(e);
                toast({
                    title: 'Error',
                    description: e?.response?.data?.message || 'Failed to save student profile',
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                });
            } finally {
                setLoading(false);

            }
        }
    }
    const { isOpen, onOpen, onClose } = useDisclosure()

    const disabilityTypeArray = Object.entries(DisabilityType);



    return (
        <Container maxW="container.xl" py={6}>
            <Flex mb={6} justify="space-between" align="center">
                <Text fontSize="2xl" fontWeight="900" color="gray.800">
                    {id === 'add' ? t('manageStudents.addNewStudent') : t('manageStudents.editStudent')}
                </Text>
                <GhostButton leftIcon={<FaArrowLeft />} onClick={() => navigate(-1)}>
                    Back
                </GhostButton>
            </Flex>

            <Stack spacing={8}>
                {/* Basic Information Section */}
                <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)">
                    <CardHeader borderBottom="1px solid" borderColor="gray.100" py={4}>
                        <HStack spacing={3}>
                            <Icon as={FiUser} color="blue.500" />
                            <Text fontSize="lg" fontWeight="bold">Basic Information</Text>
                        </HStack>
                    </CardHeader>
                    <CardBody>
                        <Flex direction={{ base: 'column', md: 'row' }} gap={10}>
                            {/* Left Side: Inputs */}
                            <VStack spacing={6} flex={1}>
                                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} w="100%">
                                    <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'fullName')}>
                                        <FormLabel fontWeight="600">{t('manageStudents.fullName')}</FormLabel>
                                        <Input
                                            value={student.fullName}
                                            onChange={(e) => setStudent({ ...student, fullName: e.target.value || '' })}
                                            variant="filled"
                                            borderRadius="10px"
                                            h="45px"
                                        />
                                        <FormErrorMessage>{getErrorMessage(formErrors, 'fullName')}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl isRequired id="stdDOB">
                                        <FormLabel fontWeight="600">{t('manageStudents.dob')}</FormLabel>
                                        <Box className="modern-datepicker-container">
                                            <NepaliDatePicker
                                                inputClassName="modern-datepicker-input"
                                                value={date}
                                                onChange={(value: string) => {
                                                    // @ts-ignore
                                                    const englishDate = NepaliDateConverter.fromAD(value).toJsDate();
                                                    setStudent({ ...student, dob: Math.abs(englishDate.getTime()) });
                                                    setDate(value)
                                                }}
                                                options={{ calenderLocale: "en", valueLocale: "en" }}
                                            />
                                        </Box>
                                    </FormControl>

                                    <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'gender')}>
                                        <FormLabel fontWeight="600">{t('manageStudents.gender')}</FormLabel>
                                        <Select
                                            onChange={(e) => setStudent({ ...student, gender: e.target.value || '' })}
                                            value={student.gender}
                                            variant="filled"
                                            borderRadius="10px"
                                            h="45px"
                                        >
                                            <option value='M'>{t('manageStudents.male')}</option>
                                            <option value='F'>{t('manageStudents.female')}</option>
                                            <option value='U'>{t('manageStudents.others')}</option>
                                        </Select>
                                        <FormErrorMessage>{getErrorMessage(formErrors, 'gender')}</FormErrorMessage>
                                    </FormControl>

                                    <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'language')}>
                                        <FormLabel fontWeight="600">{t('manageStudents.nativeLanguage')}</FormLabel>
                                        {showLanguageOthers ? (
                                            <InputGroup>
                                                <Input
                                                    value={student.language}
                                                    onChange={(e) => setStudent({ ...student, language: e.target.value || '' })}
                                                    variant="filled"
                                                    borderRadius="10px"
                                                    h="45px"
                                                />
                                                <InputRightElement h="45px">
                                                    <IconButton
                                                        h="1.75rem"
                                                        size="sm"
                                                        aria-label="Back"
                                                        onClick={() => {
                                                            setShowLanguageOthers(false);
                                                            setStudent({ ...student, language: '' })
                                                        }}
                                                        icon={<FaArrowLeft />}
                                                    />
                                                </InputRightElement>
                                            </InputGroup>
                                        ) : (
                                            <Select
                                                onChange={(e) => {
                                                    if (e.target.value === 'OTHERS') {
                                                        setShowLanguageOthers(true);
                                                        setStudent({ ...student, language: '' })
                                                    } else {
                                                        setStudent({ ...student, language: e.target.value || '' })
                                                        setShowLanguageOthers(false)
                                                    }
                                                }}
                                                value={student.language}
                                                variant="filled"
                                                borderRadius="10px"
                                                h="45px"
                                            >
                                                {['NEPALI', 'Maithili', 'Bhojpuri', 'Tharu', 'Tamang', 'Nepal Bhasa', 'Magar', 'Doteli', 'Limbu', 'Gurung', 'Rai', 'Chepang', 'OTHERS'].map((lang) =>
                                                    <option key={lang} value={lang}>{t(`manageStudents.${lang}`)}</option>
                                                )}
                                            </Select>
                                        )}
                                        <FormErrorMessage>{getErrorMessage(formErrors, 'language')}</FormErrorMessage>
                                    </FormControl>
                                </SimpleGrid>
                            </VStack>

                            {/* Right Side: Image Upload */}
                            <VStack w={{ base: '100%', md: '300px' }} align="center" spacing={4}>
                                <Text fontWeight="600" alignSelf="start">Student Photo</Text>
                                <ImageUpload
                                    onSetImage={(url: string) => setStudent({ ...student, studentImage: url })}
                                    imageUrl={student.studentImage}
                                />
                                <Text fontSize="xs" color="gray.500" textAlign="center">
                                    Upload a clear passport-sized photo.
                                </Text>
                            </VStack>
                        </Flex>
                    </CardBody>
                </Card>

                {/* Disability & IDs Section */}
                <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)">
                    <CardHeader borderBottom="1px solid" borderColor="gray.100" py={4}>
                        <HStack spacing={3}>
                            <Icon as={FiInfo} color="purple.500" />
                            <Text fontSize="lg" fontWeight="bold">Disability & IDs</Text>
                        </HStack>
                    </CardHeader>
                    <CardBody>
                        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={6}>
                            <FormControl>
                                <FormLabel fontWeight="600">{t('manageStudents.disability')}</FormLabel>
                                <Select
                                    value={disability}
                                    onChange={(e) => setDisability(e.target.value)}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    <option value='true'>{t('manageStudents.yes')}</option>
                                    <option value='false'>{t('manageStudents.no')}</option>
                                </Select>
                            </FormControl>

                            <FormControl isInvalid={hasErrorMessage(formErrors, 'disabilityType')}>
                                <FormLabel fontWeight="600">{t('manageStudents.disabilityType')}</FormLabel>
                                <Select
                                    isDisabled={disability === 'false'}
                                    value={student.disabilityType}
                                    onChange={(e) => setStudent({ ...student, disabilityType: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {disabilityTypeArray.map(([key, value]) => (
                                        <option key={key} value={value as string}>{t(`manageStudents.${key}`)}</option>
                                    ))}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'disabilityType')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={hasErrorMessage(formErrors, 'disabilityId')}>
                                <FormLabel fontWeight="600">{t('manageStudents.disabilityId')}</FormLabel>
                                <Select
                                    onChange={(e) => setStudent({ ...student, disabilityId: e.target.value || '' })}
                                    value={student.disabilityId}
                                    isDisabled={disability === 'false'}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {['Profound Disability (Red Color ID)', 'Severe Disability (Blue Color ID)', 'Moderate Disability (Yellow Color ID)', 'Mild Disability (White Color ID)', 'NO ID'].map((lang) =>
                                        <option key={lang} value={lang}>{t(`manageStudents.${lang}`)}</option>
                                    )}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'disabilityId')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={hasErrorMessage(formErrors, 'nationalId')}>
                                <FormLabel fontWeight="600">{t('manageStudents.nationalId')}</FormLabel>
                                <Input
                                    value={student.nationalId}
                                    onChange={(e) => setStudent({ ...student, nationalId: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'nationalId')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={hasErrorMessage(formErrors, 'IEMISNumber')}>
                                <FormLabel fontWeight="600">{t('manageStudents.IEMISNumber')}</FormLabel>
                                <Input
                                    value={student.IEMISNumber}
                                    onChange={(e) => setStudent({ ...student, IEMISNumber: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'IEMISNumber')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={hasErrorMessage(formErrors, 'disabilityDetail')}>
                                <FormLabel fontWeight="600">{t('manageStudents.disabilityDetail')}</FormLabel>
                                <Input
                                    value={student.disabilityDetail}
                                    onChange={(e) => setStudent({ ...student, disabilityDetail: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'disabilityDetail')}</FormErrorMessage>
                            </FormControl>
                        </SimpleGrid>
                    </CardBody>
                </Card>

                {/* Service Area & Contact Section */}
                <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)">
                    <CardHeader borderBottom="1px solid" borderColor="gray.100" py={4}>
                        <HStack spacing={3}>
                            <Icon as={FiBriefcase} color="orange.500" />
                            <Text fontSize="lg" fontWeight="bold">Service & Contact</Text>
                        </HStack>
                    </CardHeader>
                    <CardBody>
                        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'serviceArea')} gridColumn={{ lg: "span 2" }}>
                                <FormLabel fontWeight="600">{t('manageStudents.serviceArea')}</FormLabel>
                                {showServiceAreaOthers ? (
                                    <InputGroup>
                                        <Input
                                            value={student.serviceArea}
                                            onChange={(e) => setStudent({ ...student, serviceArea: e.target.value || '' })}
                                            variant="filled"
                                            borderRadius="10px"
                                            h="45px"
                                        />
                                        <InputRightElement h="45px">
                                            <IconButton
                                                h="1.75rem"
                                                size="sm"
                                                aria-label="Back"
                                                onClick={() => {
                                                    setShowServiceAreaOthers(false);
                                                    setStudent({ ...student, serviceArea: '' })
                                                }}
                                                icon={<FaArrowLeft />}
                                            />
                                        </InputRightElement>
                                    </InputGroup>
                                ) : (
                                    <HStack spacing={4} wrap="wrap" bg="gray.100" p={2} borderRadius="10px" border="1px solid" borderColor={hasErrorMessage(formErrors, 'serviceArea') ? "red.500" : "transparent"}>
                                        <Checkbox colorScheme="blue" isChecked={student.serviceArea === 'SCHOOL'} onChange={(e) => setStudent({ ...student, serviceArea: e.target.checked ? 'SCHOOL' : '' })}>
                                            {t('manageStudents.school')}
                                        </Checkbox>
                                        <Checkbox colorScheme="blue" isChecked={student.serviceArea === 'HOME'} onChange={(e) => setStudent({ ...student, serviceArea: e.target.checked ? 'HOME' : '' })}>
                                            {t('manageStudents.home')}
                                        </Checkbox>
                                        <Checkbox colorScheme="blue" isChecked={student.serviceArea === 'COMMUNITY'} onChange={(e) => setStudent({ ...student, serviceArea: e.target.checked ? 'COMMUNITY' : '' })}>
                                            {t('manageStudents.community')}
                                        </Checkbox>
                                        <Checkbox colorScheme="blue" isChecked={student.serviceArea === 'OTHERS'} onChange={(e) => {
                                            if (e.target.checked) {
                                                setShowServiceAreaOthers(true);
                                            }
                                        }}>
                                            {t('manageStudents.others')}
                                        </Checkbox>
                                    </HStack>
                                )}
                                <FormErrorMessage>{getErrorMessage(formErrors, 'serviceArea')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'category')}>
                                <FormLabel fontWeight="600">{t('manageStudents.category')}</FormLabel>
                                <Input
                                    value={student.category}
                                    onChange={(e) => setStudent({ ...student, category: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'category')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'specialDisability')}>
                                <FormLabel fontWeight="600">{t('manageStudents.specialDisability')}</FormLabel>
                                <Input
                                    value={student.specialDisability}
                                    onChange={(e) => setStudent({ ...student, specialDisability: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'specialDisability')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'contact')}>
                                <FormLabel fontWeight="600">{t('manageStudents.contact')}</FormLabel>
                                <Input
                                    value={student.contact}
                                    onChange={(e) => setStudent({ ...student, contact: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'contact')}</FormErrorMessage>
                            </FormControl>
                        </SimpleGrid>
                    </CardBody>
                </Card>

                {/* School & Therapy Section */}
                <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)">
                    <CardHeader borderBottom="1px solid" borderColor="gray.100" py={4}>
                        <HStack spacing={3}>
                            <Icon as={FiBriefcase} color="green.500" />
                            <Text fontSize="lg" fontWeight="bold">Assignments</Text>
                        </HStack>
                    </CardHeader>
                    <CardBody>
                        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'parentId')}>
                                <Flex justifyContent="space-between" mb={2}>
                                    <FormLabel fontWeight="600" mb={0}>{t('manageStudents.parentsDetails')}</FormLabel>
                                    <IconButton
                                        size="xs"
                                        colorScheme="blue"
                                        borderRadius="full"
                                        aria-label="Add Parent"
                                        onClick={() => { setAddInModal('PARENT'); onOpen(); }}
                                        icon={<MdAdd />}
                                    />
                                </Flex>
                                <Select
                                    value={student.parentId}
                                    onChange={(e) => setStudent({ ...student, parentId: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {parents.map((e) => <option key={e.id} value={e.id}>{e.displayName}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'parentId')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={hasErrorMessage(formErrors, 'schoolId')}>
                                <Flex justifyContent="space-between" mb={2}>
                                    <FormLabel fontWeight="600" mb={0}>{t('manageStudents.schoolDetails')}</FormLabel>
                                    <IconButton
                                        size="xs"
                                        colorScheme="blue"
                                        borderRadius="full"
                                        aria-label="Add School"
                                        onClick={() => { setAddInModal('SCHOOL'); onOpen(); }}
                                        icon={<MdAdd />}
                                    />
                                </Flex>
                                <Select
                                    value={student.schoolId}
                                    onChange={(e) => setStudent({ ...student, schoolId: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {school.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'schoolId')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={hasErrorMessage(formErrors, 'therapistId')}>
                                <Flex justifyContent="space-between" mb={2}>
                                    <FormLabel fontWeight="600" mb={0}>{t('manageStudents.therapistDetails')}</FormLabel>
                                    <IconButton
                                        size="xs"
                                        colorScheme="blue"
                                        borderRadius="full"
                                        aria-label="Add Therapist"
                                        onClick={() => { setAddInModal('THERAPIST'); onOpen(); }}
                                        icon={<MdAdd />}
                                    />
                                </Flex>
                                <Select
                                    value={student.therapistId}
                                    onChange={(e) => setStudent({ ...student, therapistId: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {therapist.map((e) => <option key={e.id} value={e.id}>{e.displayName}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'therapistId')}</FormErrorMessage>
                            </FormControl>
                        </SimpleGrid>
                    </CardBody>
                </Card>

                {/* Permanent Address Section */}
                <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)">
                    <CardHeader borderBottom="1px solid" borderColor="gray.100" py={4}>
                        <HStack spacing={3}>
                            <Icon as={FiMapPin} color="red.500" />
                            <Text fontSize="lg" fontWeight="bold">Permanent Address</Text>
                        </HStack>
                    </CardHeader>
                    <CardBody>
                        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'province')}>
                                <FormLabel fontWeight="600">{t('manageStudents.province')}</FormLabel>
                                <Select
                                    value={student.province}
                                    onChange={(e) => {
                                        const id = _find(address, ['name', e.target.value]);
                                        setDistrict(id ? id.id : 0);
                                        setStudent({ ...student, province: e.target.value || '' })
                                    }}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {address.map((a) => <option key={a.name} value={a.name}>{a.name}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'province')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'district')}>
                                <FormLabel fontWeight="600">{t('manageStudents.district')}</FormLabel>
                                <Select
                                    value={student.district}
                                    isDisabled={!student.province}
                                    onChange={(e) => {
                                        const id = _find(districts, ['name', e.target.value]);
                                        setLocalLevel(id ? id.id : 0);
                                        setStudent({ ...student, district: e.target.value || '' })
                                    }}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {_filter(districts, (o) => o.province_id === district).map((a) => <option key={a.name} value={a.name}>{a.name}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'district')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'localLevel')}>
                                <FormLabel fontWeight="600">{t('manageStudents.locallevel')}</FormLabel>
                                <Select
                                    value={student.localLevel}
                                    isDisabled={!student.district}
                                    onChange={(e) => setStudent({ ...student, localLevel: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {_filter(localLevelData, (o) => o.district_id === localLevel).map((a) => <option key={a.name} value={a.name}>{a.name}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'localLevel')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'localAddress')}>
                                <FormLabel fontWeight="600">{t('manageStudents.localAddress')}</FormLabel>
                                <Input
                                    value={student.localAddress}
                                    onChange={(e) => setStudent({ ...student, localAddress: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'localAddress')}</FormErrorMessage>
                            </FormControl>
                        </SimpleGrid>
                    </CardBody>
                </Card>

                {/* Temporary Address Section */}
                <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)">
                    <CardHeader borderBottom="1px solid" borderColor="gray.100" py={4}>
                        <Flex justifyContent="space-between" alignItems="center">
                            <HStack spacing={3}>
                                <Icon as={FiMapPin} color="red.300" />
                                <Text fontSize="lg" fontWeight="bold">Temporary Address</Text>
                            </HStack>
                            <Checkbox isChecked={copyAddress} colorScheme="blue" fontWeight="600" onChange={(e) => {
                                if (copyAddress) {
                                    setCopyAddress(false);
                                    setStudent({ ...student, tempProvince: '', tempDistrict: '', tempLocalLevel: '', tempLocalAddress: '' });
                                } else {
                                    setCopyAddress(true);
                                    const id = _find(address, ['name', student.province]);
                                    setDistrictTemp(id ? id.id : 0);
                                    const id1 = _find(districts, ['name', student.district]);
                                    setLocalLevelTemp(id1 ? id1.id : 0);
                                    setStudent({ ...student, tempProvince: student.province, tempDistrict: student.district, tempLocalLevel: student.localLevel, tempLocalAddress: student.localAddress });
                                }
                            }}>
                                Same as Permanent
                            </Checkbox>
                        </Flex>
                    </CardHeader>
                    <CardBody>
                        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'tempProvince')}>
                                <FormLabel fontWeight="600">{t('manageStudents.tempProvince')}</FormLabel>
                                <Select
                                    value={student.tempProvince}
                                    onChange={(e) => {
                                        const id = _find(address, ['name', e.target.value]);
                                        setDistrictTemp(id ? id.id : 0);
                                        setStudent({ ...student, tempProvince: e.target.value || '' })
                                    }}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {address.map((a) => <option key={a.name} value={a.name}>{a.name}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'tempProvince')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'tempDistrict')}>
                                <FormLabel fontWeight="600">{t('manageStudents.tempDistrict')}</FormLabel>
                                <Select
                                    value={student.tempDistrict}
                                    isDisabled={!student.tempProvince}
                                    onChange={(e) => {
                                        const id = _find(districts, ['name', e.target.value]);
                                        setLocalLevelTemp(id ? id.id : 0);
                                        setStudent({ ...student, tempDistrict: e.target.value || '' })
                                    }}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {_filter(districts, (o) => o.province_id === districtTemp).map((a) => <option key={a.name} value={a.name}>{a.name}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'tempDistrict')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'tempLocalLevel')}>
                                <FormLabel fontWeight="600">{t('manageStudents.tempLocalLevel')}</FormLabel>
                                <Select
                                    value={student.tempLocalLevel}
                                    isDisabled={!student.tempDistrict}
                                    onChange={(e) => setStudent({ ...student, tempLocalLevel: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                >
                                    {_filter(localLevelData, (o) => o.district_id === localLevelTemp).map((a) => <option key={a.name} value={a.name}>{a.name}</option>)}
                                </Select>
                                <FormErrorMessage>{getErrorMessage(formErrors, 'tempLocalLevel')}</FormErrorMessage>
                            </FormControl>

                            <FormControl isRequired isInvalid={hasErrorMessage(formErrors, 'tempLocalAddress')}>
                                <FormLabel fontWeight="600">{t('manageStudents.localAddress')}</FormLabel>
                                <Input
                                    value={student.tempLocalAddress}
                                    onChange={(e) => setStudent({ ...student, tempLocalAddress: e.target.value || '' })}
                                    variant="filled"
                                    borderRadius="10px"
                                    h="45px"
                                />
                                <FormErrorMessage>{getErrorMessage(formErrors, 'tempLocalAddress')}</FormErrorMessage>
                            </FormControl>
                        </SimpleGrid>
                    </CardBody>
                </Card>

                {/* Submit Buttons */}
                <Flex gap={4} py={8}>
                    <GhostButton
                        flex={1}
                        h="55px"
                        onClick={() => navigate(-1)}
                        isDisabled={loading}
                    >
                        {t('manageStudents.cancel')}
                    </GhostButton>
                    <BrandButton
                        flex={2}
                        h="55px"
                        isLoading={loading}
                        onClick={handleUpdateStudent}
                    >
                        {t('manageStudents.save')}
                    </BrandButton>
                </Flex>
            </Stack>

            <Modal isOpen={isOpen} onClose={onClose} size={'5xl'}>
                <ModalOverlay />
                <ModalContent p={'12px'} borderRadius="20px">
                    <ModalCloseButton />
                    {addInModal === 'SCHOOL' ? (
                        <ManageSchool
                            shouldReturn={true}
                            returnUserID={(id: string) => {
                                if (addInModal === 'SCHOOL') { setStudent({ ...student, schoolId: id }); }
                                getSchools();
                                setAddInModal('');
                                onClose();
                            }}
                            role={addInModal}
                        />
                    ) : (
                        <ManageUsers
                            shouldReturn={true}
                            returnUserID={(id: string) => {
                                if (addInModal === 'THERAPIST') { setStudent({ ...student, therapistId: id }); }
                                if (addInModal === 'PARENT') { setStudent({ ...student, parentId: id }); }
                                getTherapist();
                                getUsers();
                                setAddInModal('');
                                onClose();
                            }}
                            role={addInModal}
                        />
                    )}
                </ModalContent>
            </Modal>

            <style>{`
                .modern-datepicker-container {
                    position: relative;
                }
                .modern-datepicker-input {
                    width: 100%;
                    height: 45px;
                    padding: 0 16px;
                    border-radius: 10px;
                    background: var(--chakra-colors-gray-100);
                    border: none;
                    font-size: 16px;
                }
                .modern-datepicker-input:focus {
                    outline: 2px solid var(--chakra-colors-blue-500);
                    background: white;
                }
            `}</style>
        </Container>
    );
}
